import { render, staticRenderFns } from "./BlockedBalanceModal.vue?vue&type=template&id=23251e0c&scoped=true&"
import script from "./BlockedBalanceModal.vue?vue&type=script&lang=ts&"
export * from "./BlockedBalanceModal.vue?vue&type=script&lang=ts&"
import style0 from "./BlockedBalanceModal.vue?vue&type=style&index=0&id=23251e0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23251e0c",
  null
  
)

export default component.exports